import styles from "./Step2.module.scss";
import { Divider } from "@mui/material";
import SelectedServices from "../SelectedServices/SelectedServices";
import FreeSlots from "../FreeSlots/FreeSlots";
import ExCalendar from "../ExCalendar/ExCalendar";
import Utilities from "../utils/Utilities";

const Step2 = (props) => {
  const handleDaySelected = (value) => {
    props.onDaySelected(value);
  };
  return props.preferences ? (
    <div>
      {props.finishedWithError && (
        <div className={styles["finish-error"]}>
          <div className={styles["finish-error-title"]}>
            Prenotazione non riuscita
          </div>
          <br />
          <div className={styles["finish-error-message"]}>
            Purtroppo la tua prenotazione per il
            <span className={styles["selected-date"]}>
              {props.selectedDay && (
                <span className={styles["selected-date_part1"]}>
                  {props.selectedDay.getDate()}/
                  {props.selectedDay.getMonth() + 1} |{" "}
                </span>
              )}
              {props.selectedTime && (
                <span className={styles["selected-date_part2"]}>
                  <span>
                    {props.selectedTime.time} &gt;{" "}
                    {Utilities.getEndTime(
                      props.selectedServices,
                      props.selectedTime
                    )}
                  </span>
                </span>
              )}
            </span>
            non è più disponibile.
          </div>
        </div>
      )}
      <span className={styles["step-title"]}>
        {props.finishedWithError
          ? "Prenota in un orario diverso"
          : "Seleziona l'orario che preferisci"}
      </span>
      <div className={styles["day-selector-container"]}>
        {props.noAvailableSlots && (
          <ExCalendar
            preferences={props.preferences}
            onDateChanged={handleDaySelected}
            selectedDay={props.selectedDay}
            noAvailableSlots={props.noAvailableSlots}
          />
        )}
      </div>
      <div style={{ width: "100%" }}>
        <Divider />
      </div>
      <div className={styles["hour-selector-container"]}>
        {props.freeSlots && (
          <FreeSlots
            freeSlots={props.freeSlots}
            onTimeSelected={props.onTimeSelected}
            selectedTime={props.selectedTime}
            selectedDay={props.selectedDay}
            onDateChanged={handleDaySelected}
          />
        )}
      </div>
      <div className={styles["selected-services-container"]}>
        <SelectedServices
          services={props.services}
          employees={props.employees}
          data={props.selectedServices}
          showTotal={true}
          moreThan2Services={props.selectedServices.length > 2}
        />
      </div>

      <div className={styles["command-buttons-container"]}>
        <span className={styles["command-button"]} onClick={props.onBack}>
          + Aggiungi o rimuovi servizi
        </span>
      </div>

      {props.selectedTime && (
        <div className={styles["confirm-container"]}>
          <div className={styles["confirm-inner-container"]}>
            <button
              className={styles["confirm-book-button"]}
              isselected="no"
              onClick={props.onBookStep2}
            >
              CONTINUA
            </button>
          </div>
        </div>
      )}
    </div>
  ) : (
    <h1 style={{ textAlign: "center" }}>loading...</h1>
  );
};

export default Step2;
